/**
 * Displays feedback emitted by guest wishlist controls.
 */
class GuestWishlistNotification {
  constructor() {
    window.addEventListener('wishlistNotification', (event) => {
      this.show(event.detail);
    });
  }

  show({ message, type = 'success' } = {}) {
    if (!message) return;

    document.querySelectorAll('.wishlist-notification').forEach((notification) => {
      notification.remove();
    });

    const notification = document.createElement('div');
    notification.className = `wishlist-notification ${type}`;
    notification.setAttribute('role', 'status');
    notification.setAttribute('aria-live', 'polite');
    notification.textContent = message;
    document.body.append(notification);

    window.setTimeout(() => notification.remove(), 3500);
  }
}

new GuestWishlistNotification();